var m = require('mithril');
var prop = require('mithril/stream')
var key = require('../../libs/keybindings');
var loaders = require('../../layout/components/loaders');
var modal = require('../../layout/components/modal');
var Variable = require('../models/variable');
var fieldnetTree = require('../../network/components/fieldnetTree');
var formGroup = require('../../components/formGroup'); 

var variable = Object.create(Variable);

function urlForRecord (record) {
  return '/api/v1/' + record['@class'].toLowerCase() + '/' + record['@rid'].slice(1);
}
modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});

variable.editDialogue = function (record, options) {
  if ((typeof record.in === 'object') && record.in['@rid']) {
    record.in = record.in['@rid']
  } 

  variable.initForm(record);
  var submit = function () {
    return variable.save()
    .then(function (data) {
      modal.vm.close();
    })
  };
  key.setScope('modal');
  key('enter', 'modal', submit);

  modal.vm.title(record['@rid'] ? "Edit Point" : "Create New Point");
  modal.vm.body = variable.view;
  modal.vm.buttons([
    {
      label: "Reset",
      class: "dib mr2",
      func: variable.reset
    },
    {
      label: "Submit",
      class: "dib",
      func: submit
    },
  ])
  if (record['@rid']) {
    modal.vm.buttons().unshift({
      label: "Delete",
      class: "dib red mr2",
      func: variable.deleteDialogue.bind(variable, record)
    })
  }
  modal.vm.open()
};
variable.deleteDialogue = function (record) {
  var submit = function () {
    return variable.delete(record)
    .then(
    // Success
    function (data) {
      modal.vm.close();
      return true;
    })
  };
  key.unbind('enter');
  key.setScope('modal');
  key('enter', 'modal', submit);
  variable.initForm(record);
  modal.vm.title('Delete ' + record.name + '?');
  modal.vm.buttons([
    {
      label: "Submit",
      class: "dib",
      func: submit
    }
  ])
  modal.vm.body = prop(false);
  modal.vm.open();
};
variable.view = function () {
  return m('form.form-dark', {role:'form'}, [
    variable.errorView(),
    m(formGroup, [
      (function () {
        if (!variable.columnName) {
          return [
            m('div', {class:'form-group'}, [
              m('name', {for:'pd-name'}, 'Name'),
              m('input.form-control', {
                id:'pd-name', 
                type:'text',
                autocomplete: 'off',
                oninput: (ev) => variable.form.name(ev.target.value),
                value: variable.form.name(),
              }),
            ]),
            m('div', {class:'form-group'}, [
              m('name', {for:'pd-unit'}, 'Source Unit'),
              m('input.form-control', {
                id:'pd-unit', 
                type:'text',
                autocomplete: 'off',
                oninput: (ev) => variable.form.unit(ev.target.value),
                value: variable.form.unit(),
              }),
            ]),
            m('div', {class:'form-group'}, [
              m('name', {for:'pd-unitConversion'}, 'Unit Conversion'),
              m('input.form-control', {
                id:'pd-unitConversion', 
                type:'text',
                autocomplete: 'off',
                oninput: (ev) => variable.form.unitConversion(ev.target.value),
                value: variable.form.unitConversion(),
              }),
            ])
          ]
        } else {
          return [];
        }
      })(),
    ]),
    m(fieldnetTree, {selectedPoint: variable.form.in}),
  ])
}
module.exports = variable;
